import styled from 'styled-components';

export const CreateThresholdDialogStyles = styled.div`
  .table-container {
    min-height: 275px;
  }
  .threshold-form-details {
    width: 70%;
    border-collapse: collapse;
    margin-left: 25px;
    margin-top: 10px;
    margin-right: 25px;


    .threshold-form-input-details {
      vertical-align: middle;
      z-index: 1;
      min-width: 275px;
      padding-bottom: 10px;
      padding-left: 5px;

      .MuiCheckbox-root {
        margin-left: -10px;
      }
    }
  }
`;
